<template>
  <error-reasons :subtitle="$t('result.scan_error_detected')" :tiles="tiles" />
</template>

<script>
import ErrorReasons from '@/components/common/ErrorReasons.vue';
import errorHair from '@/assets/MobileScan/error-hair.svg';
import errorTop from '@/assets/MobileScan/error-top.svg';
import errorBottom from '@/assets/MobileScan/error-bottom.svg';
import errorOutfit from '@/assets/MobileScan/error-outfit.svg';

// Keys match the reason values returned by getScanErrorReason in modules/scan-quality-error.
const REASON_TILES = {
  hair: { icon: errorHair, label: 'result.error_cover_neck' },
  top: { icon: errorTop, label: 'result.error_top_loose' },
  bottom: { icon: errorBottom, label: 'result.error_bottoms_loose' },
  outfit: { icon: errorOutfit, label: 'result.error_outfit_loose' },
};

// Maps the phone-scan quality reasons onto the shared ErrorReasons grid.
export default {
  name: 'MobileScanError',
  components: {
    ErrorReasons,
  },
  props: {
    // the reasons returned by getScanErrorReason
    reasons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tiles() {
      return this.reasons.map(reason => REASON_TILES[reason]).filter(Boolean);
    },
  },
};
</script>
